export const padding = 6;

export const formatTicketNumber = (ticketNumber: Number) => {
  return String(ticketNumber).padStart(padding, "0");
};

// "Tractor Trailer size" Hydrovac tickets carry a "B" prefix (e.g. B-10001).
// Returns "B-" for B-series tickets, "" otherwise, to prepend to whatever number
// format a given surface already uses.
export const bPrefix = (ticket: { isBSeries?: boolean } | null | undefined) => {
  return ticket?.isBSeries ? "B-" : "";
};

// The full, unpadded ticket number including the "B-" prefix for B-series tickets
// (e.g. "B-10001" or "10001"). Use for raw display and SoilFLO bill-of-lading lookups.
export const hydrovacTicketNumber = (
  ticket: { isBSeries?: boolean; ticketNumber: number }
) => {
  return `${bPrefix(ticket)}${ticket.ticketNumber}`;
};

// Money as it reads on the royalty reports and their result summary.
export const formatCurrency = (value: number | null | undefined) =>
  value != null
    ? value.toLocaleString("en-CA", { style: "currency", currency: "CAD" })
    : "";
